import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  open(event) {
    const img = event.target.closest("img");
    if (!img) return;

    const modal = document.getElementById("image-lightbox-modal");
    const lightboxImg = modal.querySelector("img");
    lightboxImg.src = img.src;
    lightboxImg.alt = img.alt;

    bootstrap.Modal.getOrCreateInstance(modal).show();
  }
}
